module.exports = __webpack_public_path__ + "static/media/expand-wide.b5b449ef.svg";